var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6019 8.06576C14.5989 9.36079 14.2122 10.6259 13.4906 11.7012C12.769 12.7766 11.7449 13.6139 10.5476 14.1075C9.35035 14.601 8.03363 14.7286 6.76384 14.4742C5.49407 14.2198 4.3282 13.5947 3.41351 12.6779C2.49882 11.7612 1.87637 10.5939 1.6248 9.32354C1.37323 8.05318 1.50382 6.73677 2.00008 5.5406C2.49633 4.34444 3.33599 3.32219 4.41297 2.60301C5.48994 1.88384 6.7559 1.5 8.05092 1.5C8.91245 1.5 9.76555 1.66994 10.5613 2.00008C11.3571 2.33022 12.0799 2.81408 12.6884 3.42397C13.2969 4.03386 13.7791 4.75778 14.1075 5.55428C14.4358 6.35079 14.6038 7.20423 14.6019 8.06576Z",
    stroke: "#A1A7BC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.2051 13.2213L16.6243 16.6405",
    stroke: "#A1A7BC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconImg);
export default __webpack_public_path__ + "static/media/search-icon-img.9ffcdfd2b79792dbddde57c1bfd467a5.svg";
export { ForwardRef as ReactComponent };